import { render, staticRenderFns } from "./Bienvenido.vue?vue&type=template&id=6b27867a&scoped=true&"
import script from "./Bienvenido.vue?vue&type=script&lang=js&"
export * from "./Bienvenido.vue?vue&type=script&lang=js&"
import style0 from "./Bienvenido.vue?vue&type=style&index=0&id=6b27867a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27867a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLayout,VRow})
